// client/src/services/rbiCollectionService.js

/**
 * RBI Collection Search Service
 * This service provides a standardized interface for searching 
 * proprietary face collections.
 */

import { faceAPI } from './api';

export const rbiCollectionService = {
  /**
   * Search for faces in the RBI collection
   * @param {File} imageFile - The image file to analyze
   * @param {number} maxFaces - Maximum number of faces to return
   * @param {number} similarityThreshold - Minimum similarity percentage
   * @returns {Promise<Object>} - The search results
   */
  searchCollection: async (
    imageFile,
    maxFaces = 15,
    similarityThreshold = 70,
    { signal } = {}
  ) => {
    try {
      console.log('Searching RBI collection...');
      
      // Use the existing faceAPI to search the collection  
      const response = await faceAPI.searchFaces(
        imageFile, 
        "RBIfacecollection1", // Fixed collection ID
        maxFaces,
        similarityThreshold,
        { signal }
      );
      
      // Format the response in a standardized format
      return {
        success: true,
        source: "RBI Collection Search",
        matches: response.data.FaceMatches ? response.data.FaceMatches.map(match => ({
          id: match.Face.FaceId,
          score: match.Similarity,
          url: `https://rbi-face-collection.s3.amazonaws.com/${match.Face.ExternalImageId}`,
          metadata: {
            confidence: match.Face.Confidence,
            externalImageId: match.Face.ExternalImageId || 'Unknown',
            faceId: match.Face.FaceId
          }
        })) : [],
        searchInfo: {
          searchedFaceConfidence: response.data.SearchedFaceConfidence,
          searchedFaceBoundingBox: response.data.SearchedFaceBoundingBox,
          timestamp: new Date().toISOString()
        }
      };
    } catch (error) {
      if (error.name === 'AbortError' || error.code === 'ERR_CANCELED') throw error;
      console.error('RBI collection search error:', error);
      return {
        success: false,
        source: "RBI Collection Search",
        error: error.message || 'Unable to search the RBI collection'
      };
    }
  }
};
